"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gridSelectionDecoratorPlugin = void 0;
const react_1 = __importDefault(require("react"));
const SelectionDecoratorCell_1 = require("./SelectionDecoratorCell/SelectionDecoratorCell");
function gridSelectionDecoratorPlugin(config) {
    return () => {
        return {
            processColumns: (columns) => {
                const isMultiSelectEnabled = Boolean(config.isMultiSelectionEnabled);
                const firstSortedColumn = columns.find((column) => column.order === 0);
                const firstColumn = isMultiSelectEnabled
                    ? columns[0]
                    : firstSortedColumn !== null && firstSortedColumn !== void 0 ? firstSortedColumn : columns[0];
                const firstColumnCell = firstColumn.cell;
                firstColumn.cell = (props) => {
                    props.column.hasBigLeftIntent = !isMultiSelectEnabled;
                    return (react_1.default.createElement(SelectionDecoratorCell_1.SelectionDecoratorCell, { isSelected: config.isSelected(props.rowIndex) }, firstColumnCell(props)));
                };
                if (!isMultiSelectEnabled) {
                    const firstColumnHeader = firstColumn.header;
                    firstColumn.header = (props) => {
                        props.column.hasBigLeftIntent = true;
                        return firstColumnHeader(props);
                    };
                }
                return [...columns];
            }
        };
    };
}
exports.gridSelectionDecoratorPlugin = gridSelectionDecoratorPlugin;
//# sourceMappingURL=gridSelectionDecoratorPlugin.js.map